import React from 'react';
import {
  Input, Select, Row, Col,
} from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { Controller, useForm } from 'react-hook-form';
import AlumlyButton from '../../../components/AlumlyButton';

export type FilterEventT = {
  searchQuery?: string;
  category?: string;
  status?: string;
};

interface FormFilterEventListProps {
  selectedFilter: FilterEventT | undefined;
  setSelectedFilter: React.Dispatch<React.SetStateAction<FilterEventT | undefined>>;
}

const categories = [
  { name: 'Seminar', value: 'seminar' },
  { name: 'Social', value: 'social' },
  { name: 'Sport', value: 'sport' },
  { name: 'Charity', value: 'charity' },
];

const allStatus = [
  { name: 'Published', value: 'true' },
  { name: 'Draft', value: 'false' },
];

const FormFilterEventList: React.FC<FormFilterEventListProps> = (props) => {
  const { selectedFilter, setSelectedFilter } = props;

  const { control, reset } = useForm({
    defaultValues: {
      searchQuery: '',
      category: '',
      status: '',
    },
  });

  const handleSearch = (searchQuery: string): void => {
    setSelectedFilter({ ...selectedFilter, searchQuery });
  };

  const resetSearchAndFilter = (): void => {
    reset();
    setSelectedFilter({
      searchQuery: undefined,
      category: undefined,
      status: undefined,
    });
  };

  return (
    <div style={{
      padding: '16px 24px',
      marginTop: 24,
      background: 'white',
      border: '1px solid #E4E4E7',
      borderRadius: 12,
    }}
    >
      <Row gutter={16} align="middle">
        <Col xs={24} md={14}>
          <Controller
            name="searchQuery"
            control={control}
            render={({ field: { onChange, value } }) => (
              <Input
                allowClear
                size="large"
                prefix={<SearchOutlined style={{ color: '#A1A1AA' }} />}
                placeholder="Search by event title"
                value={value}
                onChange={(e) => {
                  onChange(e);
                  handleSearch(e.target.value);
                }}
              />
            )}
          />
        </Col>
        <Col xs={24} md={6}>
          <Controller
            name="category"
            control={control}
            render={({ field: { onChange, value } }) => (
              <Select
                size="large"
                style={{ width: '100%' }}
                placeholder="Category"
                allowClear
                value={value || undefined}
                onChange={(val) => {
                  onChange(val ?? '');
                  setSelectedFilter({ ...selectedFilter, category: val || undefined });
                }}
                options={[
                  { value: '', label: 'All' },
                  ...categories.map((cat) => ({ value: cat.value, label: cat.name })),
                ]}
              />
            )}
          />
        </Col>
        <Col xs={24} md={4}>
          <Controller
            name="status"
            control={control}
            render={({ field: { onChange, value } }) => (
              <Select
                size="large"
                style={{ width: '100%' }}
                placeholder="Status"
                allowClear
                value={value || undefined}
                onChange={(val) => {
                  onChange(val ?? '');
                  setSelectedFilter({ ...selectedFilter, status: val || undefined });
                }}
                options={[
                  { value: '', label: 'All' },
                  ...allStatus.map((s) => ({ value: s.value, label: s.name })),
                ]}
              />
            )}
          />
        </Col>
        <Col xs={24} md={4}>
          <AlumlyButton
            label="rxvWhite"
            fullWidth
            onClick={resetSearchAndFilter}
          >
            Reset filters
          </AlumlyButton>
        </Col>
      </Row>
    </div>
  );
};

export default FormFilterEventList;
